import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { WContainer, WImage } from '@next-nx/shared-ui/atoms'
import { ListImageBoxItem } from '@next-nx/shared-ui/molecules'
import styles from './ListImageBox.module.sass'


interface Props {
  item: MenuItemType
  imagePos: 'top' | 'bottom'
  imageVariant: '' | 'radius'
  children?: any[]
  className?: string
  editMode?: boolean
}

const ListImageBox = (props: Props) => {

  const { 
    item = undefined,
    imagePos = 'bottom',
    imageVariant = '',
    children = [],
    className = '',
  } = props

  return item ? (
    <div className={`${styles.root} ${styles[`root--image-${imagePos}`]} ${imageVariant ? styles[`root--image-${imageVariant}`] : ''} ${className}`}>
      <div className={styles.bg}>
        <WContainer>
          <div className={styles.content}>
            <div className={styles.imageBox}>
              <WImage 
                src={item.image}
                alt={item.name}
                title={item.name}
                maxWidth={515}
                maxHeight={357}
                layout={"fill"}
                objectFit={imageVariant === 'radius' ? "cover" : "contain"}
              />
            </div>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            {children && children.length > 0 && (
            <div className={styles.list}>
              {children?.map((x, i) => (
                <div key={i} className={`${styles.item} ${
                  imagePos === 'top' ? i < 2 ? styles['item--prev'] : styles['item--next'] : styles['item--prev']
                }`}>
                  {x}
                </div>
              ))}
            </div>
            )}
          </div>
        </WContainer>
      </div>
    </div>
  ) : <></>
}

export default ListImageBox
